export default __webpack_public_path__ + "static/media/casa-portatil.5fc3a18b.jpg";